import type { FacilitySearchResult } from "../queries";

const archivedSecondaryClassName = "italic text-sys-brand-outline";

export function getFacilityNameSecondaryText(row: FacilitySearchResult) {
  const isArchived = row.archivedAt != null;

  if (isArchived && row.legacyId) {
    return <span className={archivedSecondaryClassName}>Archived • ID: {row.legacyId}</span>;
  }

  if (isArchived) {
    return <span className={archivedSecondaryClassName}>Archived</span>;
  }

  if (row.legacyId) {
    return `ID: ${row.legacyId}`;
  }

  return " ";
}
